import {
  string as yupString,
  number as yupNumber,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, maxLength, uniqueWith, notAllowed, countryTaxTypeValidator } from '../../shared/forms/validators';
import { decimalWithSignFormatter } from '../../shared/helpers';
import { US_COUNTRY_TAX_TYPES } from '../../shared/constants';

const schema = [
  {
    name: 'countryTaxType',
    component: InputFormik,
    meta: { label: 'Country Tax Type' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [required, maxLength(3), countryTaxTypeValidator,
        uniqueWith(['countryCode'], 'Country Tax Type already exists.'),
        notAllowed([US_COUNTRY_TAX_TYPES.US_FBOS], 'US3 Country Tax Type is used for FBOS')],
    },
    conditions: [
      {
        when: ({ formik }) => (
          formik.values.countryTaxType === US_COUNTRY_TAX_TYPES.US_FEDERAL_INCOME_TAX
        ),
        then: {
          additionalProps: (_, formik) => ( { onBlur: () => {
            formik.setFieldValue('description', 'US Federal Income Tax');
          },
          }),
        },
      },
    ],
    additionalProps: { required: true },
  },
  {
    name: 'countryCode',
    component: SelectFormik,
    meta: { label: 'Country Code', optionsKey: 'countryCodeOptions' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'enabledFlag',
    component: SelectFormik,
    meta: { label: 'Enabled Flag', optionsKey: 'enabledFlagOptions' },
    options: {
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'description',
    component: InputFormik,
    meta: { label: 'Description' },
    options: {
      yupType: yupString(),
      validationRules: [required, maxLength(240)],
    },
    conditions: [
      {
        when: ({ formik }) => (
          formik.values.countryTaxType === US_COUNTRY_TAX_TYPES.US_FEDERAL_INCOME_TAX
        ),
        then: {
          additionalProps: { disabled: true },
        },
      },
    ],
    additionalProps: { required: true },
  },
  {
    name: 'taxRate',
    component: InputFormik,
    meta: { label: 'Current Tax Rate' },
    options: {
      yupType: yupNumber(),
      validationRules: [required],
    },
    additionalProps: { required: true, suffix: '%', valueFormatter: decimalWithSignFormatter },
  },
  {
    name: 'plAccount',
    component: SelectFormik,
    meta: { label: 'Current P&L', optionsKey: 'plAccountOptions' },
    options: {
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'bsAccount',
    component: SelectFormik,
    meta: { label: 'Current BS', optionsKey: 'bsAccountOptions' },
    options: {
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'defTaxRate',
    component: InputFormik,
    meta: { label: 'Deferred Tax Rate' },
    options: {
      yupType: yupNumber(),
      validationRules: [required],
    },
    additionalProps: { required: true, suffix: '%', valueFormatter: decimalWithSignFormatter },
  },
  {
    name: 'defPlAccount',
    component: SelectFormik,
    meta: { label: 'Deferred P&L', optionsKey: 'defPlAccountOptions' },
    options: {
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'defBsAccount',
    component: SelectFormik,
    meta: { label: 'Deferred BS', optionsKey: 'defBsAccountOptions' },
    options: {
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true, virtualized: true },
  },
];

export default schema;
